import * as _ from 'lodash';
import { Formatter } from 'slickgrid';

const DEFAULTS = {
  space: 2,
};

export interface JsonifyFormatterOptions {
  space?: number;
}

export function jsonify<T>(opts: JsonifyFormatterOptions): Formatter<T> {
  const vals = { ...DEFAULTS, ...opts };

  return function jsonifyFormatter(row, cell, value, columnDef, data) {
    return _.isObject(value) ? JSON.stringify(value, null, vals.space) : '';
  };
}
